import { Group, Stack, createStyles } from '@mantine/core';
import type { PolicyViolationOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { memo } from 'react';
import {
	ProgressIndicator,
	type ProgressIndicatorVariants,
} from '../../ProgressIndicator/ProgressIndicator';

interface PolicyBreakdownItemProps {
	violation: PolicyViolationOut;
}

const useStyles = createStyles((theme) => ({
	container: {
		padding: theme.spacing.sm,
		borderBottom: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		'&:last-child': {
			borderBottom: 'none',
		},
	},
}));

function getVariantFromPassingStatus(
	isPassing: boolean
): ProgressIndicatorVariants {
	return isPassing ? 'success' : 'critical';
}

export const PolicyBreakdownItem = memo(
	({ violation }: PolicyBreakdownItemProps) => {
		const { classes } = useStyles();

		return (
			<div className={classes.container}>
				<Group spacing="sm" noWrap>
					{violation.is_passing ? (
						<ProgressIndicator
							value={100}
							variant="success"
							bg="fill/tertiary/default"
						/>
					) : (
						<ProgressIndicator
							value={0}
							variant="warning"
							bg="fill/warning/default"
						/>
					)}
					<Stack spacing={0} sx={{ flex: 1, minWidth: 0 }}>
						<Text size="sm" weight="semibold">
							{violation.policy_rule.name || 'Unnamed Rule'}
						</Text>
						<Text size="xs" color="text/secondary/default">
							{violation.points_awarded} of {violation.points_possible} points
						</Text>
					</Stack>
				</Group>
			</div>
		);
	}
);

PolicyBreakdownItem.displayName = 'PolicyBreakdownItem';
